import React, { useState, useEffect } from "react";



import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import { collection, query, orderBy, onSnapshot, doc, updateDoc } from "firebase/firestore";
import db from "./Firebase";
import Moment from "moment";
import { extendMoment } from "moment-range";

function Community() {
    const moment = extendMoment(Moment);
    const [data, setData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");
    const [loading, setLoading] = useState(false); // ✅ Prevents UI freezing

    useEffect(() => {
        const q = query(collection(db, "nv_portfolio_details"), orderBy("created_date", "desc"));
        const unsubscribe = onSnapshot(q, (snapshot) => {
            setData(
                snapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                }))
            );
        });

        return () => unsubscribe(); // ✅ Clean up listener on unmount
    }, []);

    // Search filter by username
    const filteredData = data.filter((record) =>
        record.username.toLowerCase().includes(searchQuery.toLowerCase())
    );

    // ✅ Optimized "Approve Request" function
    const handleApproveRequest = async (id) => {
        setLoading(true); // 🔄 Show loading
        try {
            const docRef = doc(db, "nv_portfolio_details", id);
            await updateDoc(docRef, { is_published: "yes" });

            // ✅ Show success message
            // Swal.fire("Success!", "Request Approved.", "success");

            setLoading(false); // ✅ Hide loading after success
        } catch (error) {
            console.error("Error updating document:", error);
            Swal.fire("Error!", "Could not approve request.", "error");
            setLoading(false);
        }
    };

    return (
        <>
            <div className="p-2 d-flex justify-content-between">
                <Link to="/">
                    <img src="/images/menubutton.png" className="menu-toggle" alt="Menu" style={{ height: "2rem" }} />
                </Link>
            </div>

            <div className="p-3">
                <div className="card-header pb-0 px-3">
                    <h6 className="mb-2">Community Tracking Page - (Count: {data.length})</h6>
                </div>
                <input
                    type="text"
                    className="form-control form-control-sm mb-2"
                    placeholder="Search by username..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                />

                {/* 🔥 Data Table */}
                <div className="table-responsive fix-width scroll-inner">
                    <table className="table table-bordered table-hover">
                        <thead className="thead-dark" style={{ position: "sticky", top: "0" }}>
                            <tr>
                                <th>Sr. No</th>
                                <th>Name</th>
                                <th>Phone No</th>
                                <th>Username</th>
                                <th>Profession</th>
                                <th>Business Name</th>
                                <th>State</th>
                                <th>City</th>
                                <th>Created Date</th>
                                <th>Is Published</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredData.length > 0 ? (
                                filteredData.map((record, index) => (
                                    <tr key={record.id}>
                                        <td>{index + 1}</td>
                                        <td>{record.name || "N/A"}</td>
                                        <td>{record.phone_no || "N/A"}</td>
                                        <td>
                                            <a href={`https://youvati.com/${record.username}`} target="_blank" rel="noopener noreferrer">
                                                {record.username}
                                            </a>
                                        </td>
                                        <td>{record.profession || "N/A"}</td>
                                        <td>{record.business_name || "N/A"}</td>
                                        <td>{record.state || "N/A"}</td>
                                        <td>{record.city || "N/A"}</td>
                                        <td>{record.created_date ? moment(record.created_date.toDate()).format("DD/MM/YY, h:mm a") : "N/A"}</td>
                                        <td>{record.is_published || "N/A"}</td>
                                        <td>
                                            {record.is_published === "requested" && (
                                                <button
                                                    className="btn btn-success btn-sm"
                                                    onClick={() => handleApproveRequest(record.id)}
                                                    disabled={loading} // ✅ Disable button while updating
                                                >
                                                    {loading ? "Processing..." : "Approve Request"} {/* ✅ Show Loading State */}
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="11" className="text-center">
                                        No data available
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}

export default Community;



// import React, { useState, useEffect } from "react";


// import { Link } from "react-router-dom";
// import Swal from "sweetalert2";
// import { collection, query, orderBy, onSnapshot, doc, updateDoc } from "firebase/firestore";
// import db from "./Firebase";
// import Moment from "moment";
// import { extendMoment } from "moment-range";

// function Community() {
//     const moment = extendMoment(Moment);
//     const [data, setData] = useState([]);
//     const [searchQuery, setSearchQuery] = useState("");

//     useEffect(() => {
//         const fetchData = () => {
//             const q = query(collection(db, "nv_portfolio_details"), orderBy("created_date", "desc"));
//             onSnapshot(q, (snapshot) => {
//                 setData(
//                     snapshot.docs.map((doc) => ({
//                         id: doc.id,
//                         ...doc.data(),
//                     }))
//                 );
//             });
//         };

//         fetchData();
//     }, []);

//     // Search filter by phone number
//     const filteredData = data.filter((record) =>
//         record.username.includes(searchQuery)
//     );

//     // 🔥 Function to Approve Request (Change "is_published" to "yes")
//     const handleApproveRequest = async (id) => {
//         try {
//             const docRef = doc(db, "nv_portfolio_details", id);
//             await updateDoc(docRef, { is_published: "yes" });

//             // ✅ Update UI Immediately
//             setData((prevData) =>
//                 prevData.map((item) =>
//                     item.id === id ? { ...item, is_published: "yes" } : item
//                 )
//             );

//             Swal.fire("Success!", "Request Approved.", "success");
//         } catch (error) {
//             console.error("Error updating document:", error);
//             Swal.fire("Error!", "Could not approve request.", "error");
//         }
//     };

//     return (
//         <>
//             <div className="p-2" style={{ display: "flex", justifyContent: "space-between" }}>
//                 <Link to="/">
//                     <img src="/images/menubutton.png" className="menu-toggle" alt="Menu" style={{ height: "2rem" }} />
//                 </Link>
//             </div>

//             <div className="p-3">
//                 <div className="card-header pb-0 px-3">
//                     <h6 className="mb-2">Community Tracking Page - (Count: {data.length})</h6>
//                 </div>
//                 <input
//                     type="text"
//                     className="form-control form-control-sm mb-2"
//                     placeholder="Search by username..."
//                     value={searchQuery}
//                     onChange={(e) => setSearchQuery(e.target.value)}
//                 />

//                 {/* 🔥 Data Table */}
//                 <div className="table-responsive fix-width scroll-inner">
//                     <table className="table table-bordered table-hover">
//                         <thead className="thead-dark" style={{ position: "sticky", top: "0" }}>
//                             <tr>
//                                 <th>Sr. No</th>
//                                 <th>Name</th>
//                                 <th>Phone No</th>
//                                 <th>Username</th>
//                                 <th>Profession</th>
//                                 <th>Business Name</th>
//                                 <th>State</th>
//                                 <th>City</th>
//                                 <th>Created Date</th>
//                                 <th>Is Published</th>
//                                 <th>Action</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {filteredData.length > 0 ? (
//                                 filteredData.map((record, index) => (
//                                     <tr key={record.id}>
//                                         <td>{index + 1}</td>
//                                         <td>{record.name || "N/A"}</td>
//                                         <td>{record.phone_no || "N/A"}</td>
//                                         <a href={record.username} target="_blank" rel="noopener noreferrer">{record.username}</a>
//                                         <td>{record.profession || "N/A"}</td>
//                                         <td>{record.business_name || "N/A"}</td>
//                                         <td>{record.username || "N/A"}</td>
//                                         <td>{record.state || "N/A"}</td>
//                                         <td>{record.city || "N/A"}</td>
//                                         <td>{record.created_date ? moment(record.created_date.toDate()).format("DD/MM/YY, h:mm a") : "N/A"}</td>
//                                         <td>{record.is_published || "N/A"}</td>
//                                         <td>
//                                             {record.is_published === "requested" && (
//                                                 <button
//                                                     className="btn btn-success btn-sm"
//                                                     onClick={() => handleApproveRequest(record.id)}
//                                                 >
//                                                     Approve Request
//                                                 </button>
//                                             )}
//                                         </td>
//                                     </tr>
//                                 ))
//                             ) : (
//                                 <tr>
//                                     <td colSpan="11" className="text-center">
//                                         No data available
//                                     </td>
//                                 </tr>
//                             )}
//                         </tbody>
//                     </table>
//                 </div>
//             </div>
//         </>
//     );
// }

// export default Community;
